// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Group from "../../resources/layout-and-structure/Group.res.js";
import * as React from "react";
import * as Select from "../../resources/selection-and-input/Select.res.js";
import * as MenuActions from "../../resources/navigation/MenuActions.res.js";
import * as InputNumberField from "../../resources/selection-and-input/InputNumberField.res.js";
import * as Accounting__Utils from "@wino/accounting/src/Accounting__Utils.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CartProductFeeFieldset__Utils from "./CartProductFeeFieldset__Utils.res.js";

function CartProductFeeFieldset(props) {
  let onRequestProductFeeRemove = props.onRequestProductFeeRemove;
  let onRequestProductFeeReplicate = props.onRequestProductFeeReplicate;
  let onRequestProductFeeUpdate = props.onRequestProductFeeUpdate;
  let product = props.product;
  let fee = props.fee;
  let displayLabel = props.displayLabel;
  let feeRef = React.useRef(fee);
  React.useEffect(() => {
    feeRef.current = fee;
  }, [fee]);
  let onChangeAmount = amount => {
    let fee = feeRef.current;
    onRequestProductFeeUpdate(fee.id, {
      kind: fee.kind,
      amount: amount,
      id: fee.id,
      formattedAmount: fee.formattedAmount,
      totalAmount: fee.totalAmount,
      formattedTotalAmount: fee.formattedTotalAmount
    });
  };
  let inputAppender;
  if (product.TAG === "Unit") {
    inputAppender = {
      TAG: "Currency",
      _0: "EUR"
    };
  } else {
    let unit = product._0.capacityUnit;
    inputAppender = unit !== undefined ? ({
        TAG: "Custom",
        _0: I18n.toCurrencySymbol("EUR") + (`/` + unit)
      }) : ({
        TAG: "Currency",
        _0: "EUR"
      });
  }
  let defaultItem_0 = CartProductFeeFieldset__Utils.optionToText(fee.kind);
  let defaultItem_1 = CartProductFeeFieldset__Utils.optionToText(fee.kind);
  let defaultItem_2 = fee.kind;
  let defaultItem = {
    TAG: "Option",
    key: defaultItem_0,
    label: defaultItem_1,
    value: defaultItem_2
  };
  let items = Accounting__Utils.getAvailableFeeKinds(product).map(feedKind => ({
    TAG: "Option",
    key: CartProductFeeFieldset__Utils.optionToText(feedKind),
    label: CartProductFeeFieldset__Utils.optionToText(feedKind),
    value: feedKind
  }));
  let costTypeSections = [{
      items: [defaultItem].concat(items)
    }];
  return JsxRuntime.jsxs(Group.make, {
    children: [
      JsxRuntime.jsx(Select.make, {
        label: displayLabel ? I18n.t("Cost type") : undefined,
        preset: {
          NAME: "inputField",
          VAL: {
            required: false
          }
        },
        sections: costTypeSections,
        value: {
          TAG: "Single",
          _0: fee.kind
        },
        onChange: change => {
          if (change.TAG === "Single") {
            let kind = change._0;
            let fee = feeRef.current;
            return onRequestProductFeeUpdate(fee.id, {
              kind: kind,
              amount: fee.amount,
              id: fee.id,
              formattedAmount: fee.formattedAmount,
              totalAmount: fee.totalAmount,
              formattedTotalAmount: fee.formattedTotalAmount
            });
          }
        }
      }),
      JsxRuntime.jsx(InputNumberField.make, {
        value: fee.amount,
        minValue: 0,
        minPrecision: 3,
        precision: 5,
        label: displayLabel ? I18n.t("Unit amount") : undefined,
        appender: inputAppender,
        onChange: onChangeAmount
      }),
      JsxRuntime.jsxs(MenuActions.make, {
        children: [
          JsxRuntime.jsx(MenuActions.Item.make, {
            title: I18n.t("Apply to all products"),
            icon: "duplicate_v1",
            onAction: () => onRequestProductFeeReplicate(fee)
          }),
          JsxRuntime.jsx(MenuActions.Item.make, {
            title: I18n.t("Remove this fee"),
            tone: "danger",
            icon: "delete",
            onAction: () => onRequestProductFeeRemove(fee.id)
          })
        ],
        trigger: {
          TAG: "Compact",
          icon: "more_v2"
        }
      })
    ],
    grid: [
      "1fr",
      "auto",
      "max-content"
    ],
    spaceX: "medium",
    alignY: "flex-end"
  });
}

let make = React.memo(CartProductFeeFieldset, (oldProps, newProps) => oldProps.fee === newProps.fee);

let Utils;

let InnerUtils;

export {
  Utils,
  InnerUtils,
  make,
}
/* make Not a pure module */
